<template>
  <div class="card-list">
    <div
      class="item"
      v-for="item in data"
      :key="item.id"
      @click="handleItem(item)"
    >
      <div class="img">
        <van-image
          
          :src="item.goods_thumb_image"
        >
        </van-image>
      </div>
      <div class="title">{{item.goods_name}}</div>
      <div class="bottom">
        <div class="text">
          <i class="icon fa fa-heart"></i>
          {{item.goods_vr_sale_count}}人测过
        </div>
        <div class="button">立即测试</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
  name: "CardList",
  props: {
    data: {
      type: Array,
      default: () => ({}),
    },
  },
  setup() {
    const router = useRouter();
    function handleItem({ guid }) {
      router.push({
        path: "/goods",
        query: {
          guid,
        },
      });
    }
    return {
      handleItem,
    };
  },
};
</script>

<style lang="less" scoped>
.van-icon {
  font-size: 20px;
  img {
    width: 20px;
    height: 20px;
  }
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 48%;
    .pointer();
    &:nth-child(2n + 1) {
      margin-right: 4%;
    }
    margin-bottom: @padding-base;
    .img {
      width: 100%;
      min-height: 90px;
      .van-image {
        width: 100%;
        min-height: 90px;
        height: auto;
        :deep(img) {
          border-radius: 5px;
        }
      }
    }
    .title {
      font-weight: bold;
      font-size: @font-size-base;
      height: 32px;
      line-height: 32px;
      .ellipsis();
    }
    .bottom {
      .space-between();
      height: 22px;
      line-height: 22px;
      font-size: @font-size-sm;
      .text {
        color: @gray-color;
        flex: 1;
        .icon {
          color: @theme-color;
        }
      }
      .button {
        padding: 0 @padding-sm;
        color: #fff;
        background-color: @theme-color;
        border-radius: 22px;
        width: 70px;
      }
    }
  }
}
</style>